import React, { useEffect, useState, useMemo } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import redirectURL from "../redirectURL";
import { AgGridReact } from "ag-grid-react";
import { getHyphenDDMMMYYYYHHMM, getDecoder } from '../common/utils'
import Select from 'react-select'
import Swal from 'sweetalert2'




function PlantMaster() {
    const user = useMemo(() => getDecoder(), []);
    const [sweetAlert, setSweetAlert] = useState({
        show: false,
        type: 'default',
        title: ''
    })
    const defaultColDef = {
        filter: true,
        sortable: true,
        resizable: true,
        wrapText: true

    }
    const [overlay, setOverlay] = useState("show-n")
    const [showLoader, setShowLoader] = useState("show-n")
    const [rowData, setRowData] = useState([])
    const [sliderOpen, setSliderOpen] = useState("")
    const [sliderText, setSliderText] = useState("")
    const [isEditMode, setIsEditMode] = useState(false)
    const [stateOptions, setStateOptions] = useState([])
    const [zoneOptions, setZoneOptions] = useState([])
    const [selectedState, setSelectedState] = useState('')
    const [selectedZone, setSelectedZone] = useState('')
    const [consignerDetails, setConsignerDetails] = useState({
        consignerCode: '',
        consignerName: '',
        consignerAddress: '',
        consignerCity: '',
        consignerLat: '',
        consignerLng: ''
    })
    const [uid, setUid] = useState('')
    const [plantOptions, setPlantOptions] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        setShowLoader("show-m")
        let query = {}
        await redirectURL.post('/getPlants', query)
            .then(response => {
                if (response.data.status === "success") {
                    let data = response?.data?.data
                    setShowLoader("show-n")
                    setRowData(data)
                    setPlantOptions(data.map((item) => item?.consigner_code))
                }
            })
        await redirectURL.post("/consignments/getDistinctStates", query)
            .then(res => {
                const states = res.data.map(item => ({ label: item, value: item }))
                setStateOptions(states)
            })
        await redirectURL.post("/getZones", query)
            .then(res => {
                if (res?.data?.status == "success") {
                    let zone = res?.data?.data[0]?.zones
                    let zones = zone.map(item => ({ label: item, value: item }))
                    setZoneOptions(zones)
                }
            })
    }
    const onclickEditButton = async (e, param) => {
        e.preventDefault()
        setSliderText("Edit Consigner")
        setIsEditMode(true)
        setSliderOpen("slider-translate")
        setUid(param?.data?._id)
        setConsignerDetails({
            consignerCode: param?.data?.consigner_code,
            consignerName: param?.data?.consigner_name,
            consignerAddress: param?.data?.consigner_address,
            consignerCity: param?.data?.consigner_city,
            consignerLat: param?.data?.consigner_lat,
            consignerLng: param?.data?.consigner_lng
        })
        const selectedState = stateOptions.find(
            s => s.value == param.data?.consigner_state
        );
        const selectedZone = zoneOptions.find(
            s => s.value == param.data?.consigner_zone
        );
        setSelectedState(selectedState)
        setSelectedZone(selectedZone)
    }
    const colDefs = useMemo(() => {
        return [
            {
                headerName: '',
                field: '_id',
                width: 60,
                filter: false,
                cellRenderer: (param) => {
                    if (param.data?.consigner_code != undefined) {
                        return (<div> <i title="Edit" onClick={(e) => onclickEditButton(e, param)} className="fa fa-edit"></i></div>)
                    }
                    else {
                        return (<div> <i title="Edit" onClick={(e) => onclickEditButton(e, undefined)} className="fa fa-edit"></i></div>)
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: 'Consigner Code',
                field: 'consigner_code',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_code) ? params.data.consigner_code : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner Name',
                field: 'consigner_name',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_name) ? params.data.consigner_name : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner Address',
                field: 'consigner_address',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_address) ? params.data.consigner_address : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner City',
                field: 'consigner_city',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_city) ? params.data.consigner_city : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner State',
                field: 'consigner_state',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_state) ? params.data.consigner_state : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner Zone',
                field: 'consigner_zone',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_zone) ? params.data.consigner_zone : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner Latitude',
                field: 'consigner_lat',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_lat) ? params.data.consigner_lat : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner Longitude',
                field: 'consigner_lng',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_lng) ? params.data.consigner_lng : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Consigner Coordinates',
                field: 'consigner_coordinates',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.consigner_coordinates) ? params.data.consigner_coordinates : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Created Date',
                field: 'created_date',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Created By',
                field: 'created_by',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.created_by) ? params.data.created_by : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Updated On',
                field: 'updated_on',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.updated_on) ? getHyphenDDMMMYYYYHHMM(params.data.updated_on) : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
            {
                headerName: 'Modified By',
                field: 'updated_by',
                valueGetter: function (params) {
                    try {
                        return !['', null, undefined].includes(params.data.updated_by) ? params.data.updated_by : ''
                    }
                    catch (e) {
                        return ''
                    }
                }
            },
        ]
    })


    const handleAddConsigner = async () => {
        setSliderOpen("slider-translate")
        setSliderText("Add Consigner")
        setOverlay("show-m")
        setIsEditMode(false)
    }

    const handleConfirm = () => {
        setSweetAlert({
            show: false,
            type: '',
            title: ''
        })
        setSliderOpen("")
        setOverlay("show-n")
        loadData()
    }
    const handleConsignerData = (e, name) => {
        e.preventDefault();
        let value = e.target.value;
        let alphaNumericRegex = /^[A-Za-z0-9]*$/
        const addressRegex = /^[A-Za-z0-9 #.,\/-]*$/;
        let alphabetsRegex = /^[A-Z a-z]*$/
        const decimalRegex = /^\d*\.?\d*$/;
        switch (name) {
            case "consigner_code":
                if (!alphaNumericRegex.test(value)) {
                    return ''
                }
                setConsignerDetails((prev) => ({
                    ...prev,
                    consignerCode: value.toUpperCase()
                }))
                break;
            case "consigner_name":
                if (!alphaNumericRegex.test(value)) {
                    return ''
                }
                setConsignerDetails((prev) => ({
                    ...prev,
                    consignerName: value
                }))
                break;
            case "consigner_address":
                if (!addressRegex.test(value)) {
                    return ''
                }
                setConsignerDetails((prev) => ({
                    ...prev,
                    consignerAddress: value
                }))
                break;
            case "consigner_city":
                if (!alphabetsRegex.test(value)) {
                    return ''
                }
                setConsignerDetails((prev) => ({
                    ...prev,
                    consignerCity: value
                }))
                break;
            case "consigner_lat":
                if (!decimalRegex.test(value)) {
                    return ''
                }
                setConsignerDetails((prev) => ({
                    ...prev,
                    consignerLat: value
                }))
                break;
            case "consigner_lng":
                if (!decimalRegex.test(value)) {
                    return ''
                }
                setConsignerDetails((prev) => ({
                    ...prev,
                    consignerLng: value
                }))
                break;
            default:
                return ''


        }
    }
    const handleClose = () => {
        setSliderOpen("")
        setOverlay("show-n")
        setConsignerDetails({
            consignerCode: '',
            consignerName: '',
            consignerAddress: '',
            consignerCity: '',
            consignerZone: '',
            consignerState: '',
            consignerLat: '',
            consignerLng: ''
        })
        setSelectedState("")
        setSelectedZone("")
    }
    const saveData = async (e) => {
        e.preventDefault()
        if (isEditMode === false) {
            if (plantOptions?.includes(consignerDetails?.consignerCode)) {
                Swal.fire({
                    icon: "error",
                    text: "Connsigner Code Already Exists",
                });
            }
            else {
                let query = {
                    consigner_code: consignerDetails?.consignerCode,
                    consigner_name: consignerDetails?.consignerName,
                    consigner_address: consignerDetails?.consignerAddress,
                    consigner_state: selectedState?.value,
                    consigner_zone: selectedZone?.value,
                    consigner_city: consignerDetails?.consignerCity,
                    consigner_lat: consignerDetails?.consignerLat,
                    consigner_lng: consignerDetails?.consignerLng,
                    user: user?.email
                }
            }
        }
        else{
        let query = {
            consigner_code: consignerDetails?.consignerCode,
            consigner_name: consignerDetails?.consignerName,
            consigner_address: consignerDetails?.consignerAddress,
            consigner_state: selectedState?.value,
            consigner_zone: selectedZone?.value,
            consigner_city: consignerDetails?.consignerCity,
            consigner_lat: consignerDetails?.consignerLat,
            consigner_lng: consignerDetails?.consignerLng,
            user: user?.email
        }
        if (isEditMode) {
            query["isEditMode"] = "true"
            query["id"] = uid
        }
        await redirectURL.post("/saveConsigner", query)
            .then(resp => {
                if (resp?.data?.status == "success") {
                    setSweetAlert({
                        show: true,
                        type: 'success',
                        title: resp?.data?.message
                    })
                }
                else {
                    setSweetAlert({
                        show: true,
                        type: 'danger',
                        title: "failed to save"
                    })
                }
            })
        }
    }
    return (
        <>
            <SweetAlert
                show={sweetAlert?.show}
                type={sweetAlert?.type}
                title={sweetAlert?.title}
                onConfirm={handleConfirm}
            />
            <div className='container-fluid'>
                <div className="row d-flex justify-content-between">
                    <h5 className="ml-3">Consigner Master</h5>
                    <button className="btn btn-warning" style={{ float: "left", border: "none", marginBottom: "5px", marginRight: "15px" }} onClick={handleAddConsigner}><i className="icon-plus"></i>&nbsp; Add Consigner </button>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className={"ag-theme-balham mt-8"} style={{ height: '600px', width: '100%', paddingTop: "1rem" }}>
                            <AgGridReact defaultColDef={defaultColDef} columnDefs={colDefs} rowData={rowData} pagination={true} paginationAutoPageSize={50} />

                        </div>
                    </div>
                </div>

                {sliderOpen && <div className={"slide-r " + sliderOpen}>
                    <div className="slide-r-title"><h4>
                        {sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "12px" }} onClick={handleClose}>X</span></h4></div >

                    <div className='mt-3'>
                        <form onSubmit={saveData}>
                            <div className='col-xl-12'>
                                <label className=''>Consigner Code<span className='required_field'>*</span></label>
                                {isEditMode ? <input disabled className='form-control' value={consignerDetails?.consignerCode} /> : <input type="text" className='form-control' value={consignerDetails?.consignerCode} onChange={(e) => handleConsignerData(e, "consigner_code")} required />}
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner Name<span className='required_field'>*</span></label>
                                {isEditMode ? <input disabled className='form-control' value={consignerDetails?.consignerName} /> : <input type="text" className='form-control' value={consignerDetails?.consignerName} onChange={(e) => handleConsignerData(e, "consigner_name")} required />}
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner Address<span className='required_field'>*</span></label>
                                <input
                                    type='text'
                                    onChange={(e) => handleConsignerData(e, "consigner_address")}
                                    value={consignerDetails?.consignerAddress}
                                    className='form-control'
                                    required />
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner City<span className='required_field'>*</span></label>
                                <input
                                    type='text'
                                    onChange={(e) => handleConsignerData(e, "consigner_city")}
                                    value={consignerDetails?.consignerCity}
                                    className='form-control'
                                    required />
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner State<span className='required_field'>*</span></label>
                                <Select
                                    options={stateOptions}
                                    value={selectedState}
                                    onChange={(e) => setSelectedState(e)}
                                    required />
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner Zone<span className='required_field'>*</span></label>
                                <Select
                                    options={zoneOptions}
                                    value={selectedZone}
                                    onChange={(e) => setSelectedZone(e)}
                                    required />
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner Latitude<span className='required_field'>*</span></label>
                                <input
                                    type='text'
                                    onChange={(e) => handleConsignerData(e, "consigner_lat")}
                                    value={consignerDetails?.consignerLat}
                                    className='form-control'
                                    required />
                            </div>
                            <div className='col-xl-12'>
                                <label className='mt-2'>Consigner Longitude<span className='required_field'>*</span></label>
                                <input
                                    type='text'
                                    onChange={(e) => handleConsignerData(e, "consigner_lng")}
                                    value={consignerDetails?.consignerLng}
                                    className='form-control'
                                    required />
                            </div>
                            <button type="submit" className="btn btn-success ml-3 mt-3">Submit</button >
                        </form>
                    </div>

                </div>}
            </div>

            <div className={"overlay-part " + overlay} onClick={handleClose}></div>
            <div className={"dataLoadpage " + (showLoader)}>
            </div>
            <div className={"dataLoadpageimg " + (showLoader)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </>
    )
}

export default PlantMaster